module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"panel":"Dashboard","aboutCompany":"Company","careerPortal":"Portal","vacancies":"Jobs","qr":"QR codes","partnership":"Partnership","candidates":"Candidates"}}')
  delete Component.options._Ctor
}
